import {TypeImpl} from './TypeImpl';
import {Type} from './Type';

export class TypeAnchorsScroll extends TypeImpl implements Type {

    protected link: HTMLLinkElement;

    public execute(): void {
        let globalContext = this;
        this.link.addEventListener('click', function (e) {
            e.preventDefault();
            const blockId = this.getAttribute('href').substr(1);
            setTimeout(function () {
                globalContext.smoothScroll(blockId);
            }, 100);
        });
    }

    public setTarget(target: HTMLInputElement): void {
        // @ts-ignore: Unreachable code error
        this.link = (target as HTMLLinkElement);
    }

    private currentYPosition() {
        // Firefox, Chrome, Opera, Safari
        if (self.pageYOffset) return self.pageYOffset;
        // Internet Explorer 6 - standards mode
        if (document.documentElement && document.documentElement.scrollTop)
            return document.documentElement.scrollTop;
        // Internet Explorer 6, 7 and 8
        if (document.body.scrollTop) return document.body.scrollTop;
        return 0;
    }


    private elmYPosition(eID: any) {
        let elm = document.getElementById(eID);

        if (!elm) {
            return false;
        }

        let y = elm.offsetTop;
        let node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
            // @ts-ignore: Unreachable code error
            node = node.offsetParent;
            y += node.offsetTop;
        }
        return y - 50;
    }


    private smoothScroll(eID: any) {
        let startY = this.currentYPosition();
        let stopY = this.elmYPosition(eID);

        if (!stopY) {
            return false;
        }

        let distance = stopY > startY ? stopY - startY : startY - stopY;
        if (distance < 100) {
            scrollTo(0, stopY); return;
        }
        let speed = Math.round(distance / 100);
        if (speed >= 20) speed = 20;
        let step = Math.round(distance / 25);
        let leapY = stopY > startY ? startY + step : startY - step;
        let timer = 0;
        if (stopY > startY) {
            for (let i = startY; i < stopY; i += step) {
                setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                leapY += step; if (leapY > stopY) leapY = stopY; timer++;
            } return;
        }
        for (let i = startY; i > stopY; i -= step) {
            setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
            leapY -= step; if (leapY < stopY) leapY = stopY; timer++;
        }
    }
}
